const getSlas = async (skus) => {
  try {
    const response = await fetch(
      `${process.env.SLA_API_URL}/prod/sku-sla/search`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-API-Key': process.env.SLA_API_KEY,
        },
        body: JSON.stringify({ skuIds: skus }),
      },
    );
    if (response.ok) {
      return response.json();
    }
    return undefined;
  } catch (error) {
    return undefined;
  }
};

const slaService = {
  getSlas,
};

export default slaService;
